import React from "react";
import { BCMSCurrency, useStateManager, BrandingStyle } from "bcms-react";

import './styles.css';

export default function DepositHistorySearchCriteria(props) {
    const { ui, data, onSearchReset } = useStateManager();

    const search = data.submittedSearch;
    const criteria = ui.showCriteria;
    const showCustomDateRange = ui.showCustomDateRange;

    // getCriteriaString :: STRING -> STRING
    // function for build the criteria string based on what was set in the form
    const getCriteriaString = key => {
        const value = search[key];
        switch (key) {
            case "account": return `Account: ${search.account === 'all' ? 'All Accounts' : search.account.nickname}`;
            case "date":
                var message = `Date Range: ${search.ranges.get(value)}`;
                if (showCustomDateRange && search.startDate && search.endDate) {
                    message = `Date Range: ${search.startDate.format("m/d/Y")} - ${search.endDate.format("m/d/Y")}`;
                } else if (showCustomDateRange && (search.startDate === undefined || search.endDate == undefined)) {
                    message = "";
                }
                return message;
            //case "description": return `Description: ${ value }`;
            case "amount": return `Amount: ${BCMSCurrency.init(value).format()}`;
            case "minAmount": return `Min Amount: ${BCMSCurrency.init(value).format()}`;
            case "maxAmount": return `Max Amount: ${BCMSCurrency.init(value).format()}`;
            //case "check": return `Check Number: ${ value }`;
        }
    };

    // Build the criteria string
    //const searchCriteria = ["account", "date", "amount", "description", "check"].reduce((result, key) => {
    var searchCriteria = ["account", "date", "amount", "minAmount", "maxAmount"].reduce((result, key) => {
        if (Object.keys(search.filters).includes(key)) {
            result += `${getCriteriaString(key)}; `;
        }

        return result;
    }, "");

    // Remove the last 2 characters in the message which are "; ".
    searchCriteria = searchCriteria.slice(0, -2);

    return (
        <>
            {
                criteria &&
                <BrandingStyle style={{ "backgroundColor": "search_bg_abi22" }} 
                className="flex-container flex-horizontal transaction-search-criteria"
                element={
                    <div >
                        <BrandingStyle style={{ "color": "search_text_abi22" }} element={
                            <p><b>Search Criteria: </b>
                                <span>{searchCriteria}</span>
                            </p>
                        } />
                        <a className="text-right clickable" onClick={onSearchReset}>Clear Search</a>
                    </div>
                } />
            }
        </>
    );
}